// 幣圈新知
'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import '../../../styles/swipers.scss'; // 輪播樣式

import { ABOUT_CONTENT, ABOUT_INFO } from "../common/constant";
import CRAboutItem from "./CRAboutItem";

const CRAbout = () => {

    return(
        <section id="cr-about" className="cr-section cr-about w-full h-screen 
            asm:min-h-[750px] asm:h-[380vh] 
            usm:w-screen usm:h-[fit-content]
        ">
            {/* 文字區 */}
            <div className="left-wrap relative w-[70%] my-auto h-auto asm:pt-[145px] pl-[135px] z-[1] ulg:w-[100%]  usm:px-[16px]">

                <div className="flex flex-col gap-y-[74px] w-[518px] usm:w-full usm:gap-y-[35px]">

                    <div className="title-wrap about-title-wrap w-full asm:whitespace-nowrap">
                        <p className="text-russo text-red0 text-[36px] leading-[200%] font-[400]">{ABOUT_CONTENT?.[0]}</p>
                        <p className="text-russo text-black text-[65px] leading-none font-[300] usm:text-[12vw]">{ABOUT_CONTENT?.[1]}</p>
                        <p className="text-red0 text-bd2n ">{ABOUT_CONTENT?.[2]}</p>
                    </div>

                    <Swiper
                        id="about-swiper"
                        className="content-wrap w-full about-content-wrap flex asm:[&>.swiper-wrapper]:flex usm:pointer-events-auto"
                        loop={true}
                        pagination={{ clickable: true }}
                        modules={[ Autoplay, Pagination]}
                        spaceBetween={0}
                        slidesPerView={1}
                        centeredSlides={true} // 居中顯示當前 slide
                        direction={'horizontal'} // 水平方向
                        autoplay={{
                            delay: 4000,
                        }}
                    >
                        {Object.values(ABOUT_INFO).map((item,i)=>
                            <SwiperSlide
                                key={`about-item-${i}`}
                                className="about-item w-full h-[300px] bg-yellow text-jblack flex-shrink-0 usm:h-full pr-[20px]"
                            >
                                <CRAboutItem
                                    num={i+1}
                                    info={item}
                                />
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default CRAbout;



